import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";
import { topics } from "@/mocks/topics";
import VideoCard from "@/components/base/VideoCard";
import SectionHeading from "@/components/feature/SectionHeading";
import VideoCarousel from "@/components/feature/VideoCarousel";
import HeroIntro from "./components/HeroIntro";
import HotRanking from "./components/HotRanking";
import TopicGrid from "./components/TopicGrid";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  const categoryNameMap: Record<string, string> = categories.reduce(
    (acc, cat) => ({ ...acc, [cat.id]: cat.name }),
    {},
  );

  const featured = [...videos]
    .sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1))
    .slice(0, 5);

  const latest = [...videos]
    .sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1))
    .slice(0, 6);

  const hottest = [...videos].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <div className="w-full">
      <HeroIntro categories={categories} />

      {/* Carousel */}
      <section className="w-full">
        <div className="mx-auto w-full max-w-[1400px] px-4 pb-10 md:px-6">
          <VideoCarousel videos={featured} categoryNameMap={categoryNameMap} />
        </div>
      </section>

      {/* Latest + ranking */}
      <section className="w-full">
        <div className="mx-auto w-full max-w-[1400px] px-4 pb-12 md:px-6">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="lg:col-span-2">
              <SectionHeading
                icon="ri-film-line"
                title="最新视频"
                subtitle="按发布时间排序，刚刚上线的娱乐热闻"
              />
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {latest.map((video) => (
                  <VideoCard
                    key={video.id}
                    video={video}
                    categoryName={categoryNameMap[video.categoryId]}
                  />
                ))}
              </div>
              <div className="mt-6 flex justify-center">
                <Link
                  to="/category/star-latest"
                  className="flex items-center gap-2 rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
                >
                  浏览全部视频
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            <aside className="flex flex-col gap-6">
              <HotRanking videos={hottest} />

              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="mb-4 flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                    <i className="ri-apps-2-line"></i>
                  </span>
                  <h3 className="font-heading text-base font-black text-foreground-950">
                    浏览分类
                  </h3>
                </div>
                <div className="flex flex-col gap-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.id}`}
                      className="flex items-center justify-between rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-600 cursor-pointer"
                    >
                      <span className="flex items-center gap-2">
                        <i className={`${cat.icon} text-accent-500`}></i>
                        {cat.name}
                      </span>
                      <i className="ri-arrow-right-s-line text-foreground-400"></i>
                    </Link>
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* Topics */}
      <section id="topics" className="w-full scroll-mt-20 bg-background-100">
        <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
          <SectionHeading
            icon="ri-layout-grid-line"
            title="主题专题合集"
            subtitle="围绕热点持续更新的系列内容，点进去一次看个够"
          />
          <TopicGrid topics={topics} />
        </div>
      </section>

      <SiteIntro />
    </div>
  );
}